export default "__VITE_ASSET__C6zw0in1__"